<template>
  <b-container fluid>
    <b-row class="bg-custom align-items-center">
      <b-col cols="auto" style="margin-left: 25%">
        <img
          src="@/assets/images/logo/soulpay.png"
          alt="SoulPay"
          style="height: 50px"
        />
      </b-col>
      <b-col cols="auto">
        <h2 class="mb-0 text-white">Link de Pagamento</h2>
      </b-col>
    </b-row>
    <b-card
      v-if="renderPage"
      class="mt-3 mx-auto"
      style="max-width: 900px"
      body-class="p-2"
    >
      <b-row class="mt-1 justify-content-center">
        <b-col
          cols="12"
          class="d-flex justify-content-center align-items-center mb-0"
        >
          <b-card
            class="status-container d-flex flex-column justify-content-center align-items-center p-0 text-center"
            style="
              min-height: 15px;
              border-radius: 12px;
              width: 100%;
              max-width: 220px;
            "
          >
            <feather-icon
              :icon="icon"
              size="40"
              :class="`text-${res.link.status.variant}`"
            />
            <span
              class="status-text mt-2"
              :class="`text-${res.link.status.variant}`"
            >
              {{ res.link.status.status }}
            </span>
          </b-card>
        </b-col>

        <b-col cols="12">
          <Receipt type="transaction" :receipt-data="res" />
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { BContainer, BCard, BAlert, BRow, BCol } from "bootstrap-vue";

import { getLink } from "@/service/pay/pay";
import Receipt from "@/layouts/components/Receipt.vue";

export default {
  components: {
    BContainer,
    BCard,
    BAlert,
    BRow,
    BCol,
    Receipt,
  },
  data() {
    return {
      showNSU: false,
      showAUTH: false,
      installmentsText: null,
      renderPage: false,
      icon: '',
      res: {
        link: {
          status: {
            icon: null,
          },
        },
        payment: {},
        product: {},
        customer: {},
        user: {},
      },
  statusColor: 'sucess',
      statusType: {
        1: {
          status: 'Aprovado',
          variant: 'success',
          icon: 'CheckCircleIcon',
          code: 1,
        },
        2: {
          status: 'Não Autorizado',
          variant: 'danger',
          icon: 'XCircleIcon',
          code: 2,
        },
        3: {
          status: 'Revisão',
          variant: 'warning',
          icon: 'AlertCircleIcon',
          code: 3,
        },
        8: {
          status: 'Falha na Recorrência',
          variant: 'danger',
          icon: 'XCircleIcon',
          code: 8,
        },
        9: {
          status: 'Criado',
          variant: 'success',
          icon: 'CheckCircleIcon',
          code: 9,
        },
        11: {
          status: 'Aguardando Pagamento',
          variant: 'secondary',
          icon: 'ClockIcon',
          code: 11,
        },
        12: {
          status: 'Expirado',
          variant: 'warning',
          icon: 'XIcon',
          code: 12,
        },
        13: {
          status: 'Pix Pago',
          variant: 'success',
          icon: 'CheckCircleIcon',
          code: 13,
        },
      },
    }
  },
  async mounted() {
    this.renderPage = false
    await this.searchTransaction()
    this.res.link.status = this.statusType[this.res.link.status]
    this.icon = this.res.link.status.icon
    this.renderPage = true
  },
  methods: {
    async searchTransaction() {
      const hash = window.location.pathname.split('/')[3]
      const response = await getLink('payment-link', hash)
      if (response.status === 200) {
      if (response.data.link.status === 1 || response.data.link.status === 2 || response.data.link.status === 3 || response.data.link.status === 13 ) {
        this.res = response.data
        } else { this.$router.push(`/link-pagamento/1/${hash}`) }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@core/scss/vue/pages/page-payment-status";
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap");
h1,h2,h3,h4,h5,h6,p,a,
label {
  font-family: "Poppins", sans-serif;
}
</style>
